// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"603ecc1f","277":"661a4dbe","509":"76a20cf1","640":"3d3c4199","982":"2b236251"}[chunkId] + ".chunk.js";
};